/* eslint-disable no-unused-vars */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  Grid,
  Typography
} from '@mui/material';
import axios from 'axios';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import React, { useEffect, useState } from 'react';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';

// Fix Leaflet marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
});

export default function SingleLocationMapAccordion({
  lat,
  lng,
  label = 'Location'
}) {
  const [address, setAddress] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchAddress() {
      try {
        const res = await axios.get(
          'https://nominatim.openstreetmap.org/reverse',
          {
            params: {
              format: 'jsonv2',
              lat,
              lon: lng
            }
          }
        );
        setAddress(res.data.display_name || 'Unknown address');
      } catch (err) {
        setAddress('Failed to fetch address');
      } finally {
        setLoading(false);
      }
    }
    fetchAddress();
  }, [lat, lng]);

  return (
    <Grid item xs={12} sm={6}>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography sx={{ fontWeight: 600 }}>{label}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box mb={2}>
            <MapContainer
              center={[lat, lng]}
              zoom={13}
              scrollWheelZoom={false}
              style={{ height: 250, width: '100%' }}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; OpenStreetMap contributors"
              />
              <Marker position={[lat, lng]}>
                <Popup>{address || 'Fetching address...'}</Popup>
              </Marker>
            </MapContainer>
          </Box>

          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Address:
          </Typography>
          <Typography variant="body2">
            {loading ? <CircularProgress size={16} /> : address}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
